// removed by extract-text-webpack-plugin
module.exports = {"bubble":"NotificationBubble__bubble___1ewnI","pulsate":"NotificationBubble__pulsate___3uC9r","bubble-out":"NotificationBubble__bubble-out___2dtTD NotificationBubble__bubble___1ewnI","pulsateOut":"NotificationBubble__pulsateOut___2Er7N"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/NotificationBubble/NotificationBubble.scss
// module id = 556
// module chunks = 0